import Btn from '../Button'
import { useDocs } from 'data/data'

function buildPageSelection(pageNumber, numberOfPages, callbackFunc) {
    if (numberOfPages === 0)
        return

    let maxNumberOfPageButtons = 4

    let minNumber = pageNumber
    let maxNumber = pageNumber
    const checkIfNumbersAreFound = (min, max) => { 
        if (numberOfPages === 1)
            return true;

        let count = max - min

        if (count === numberOfPages)
            return true;

        return count === maxNumberOfPageButtons
    }

    for (let i = 0; i < maxNumberOfPageButtons; i++) {
        if (maxNumber !== numberOfPages)
            maxNumber++
        if (checkIfNumbersAreFound(minNumber, maxNumber))
            break;
        if (minNumber !== 1) 
            minNumber--
        if (checkIfNumbersAreFound(minNumber, maxNumber))
            break;
    }

    let buttons = []
    buttons.push(<Btn onClick={() => { callbackFunc('<') }}>{'<'}</Btn>) 

    if (minNumber !== 1) {
        buttons.push(<Btn onClick={() => { callbackFunc(1) }}>{1}</Btn>)
        if (minNumber - 1 !== 1)
            buttons.push(<span>...</span>)
    }

    for (let i = minNumber; i <= maxNumber; i++) {
        buttons.push(<Btn onClick={() => { callbackFunc(i) }} isPrimary={pageNumber === i}>{i}</Btn>)
    }

    if (maxNumber !== numberOfPages) {
        if (maxNumber + 1 !== numberOfPages)
            buttons.push(<span>...</span>)
        buttons.push(<Btn onClick={() => { callbackFunc(numberOfPages) }}>{numberOfPages}</Btn>)
    }

    buttons.push(<Btn onClick={() => { callbackFunc('>') }}>{'>'}</Btn>)

    return buttons
}

function PageSelector() {
    const { stats, pageNumber, pageLimit, applyPageNumber, applyPageLimit } = useDocs() 

    let numberOfPages = Math.ceil(stats.count / pageLimit)

    const handleClick = (buttonLabel) => {
        if (buttonLabel === '<') {
            if (pageNumber === 1)
                return
            applyPageNumber(pageNumber - 1)
            return
        }

        if (buttonLabel === '>') {
            if (pageNumber === numberOfPages)
                return
            applyPageNumber(pageNumber + 1)
            return
        }

        if (isNaN(buttonLabel)) {
            console.log("unsupported page selector click: " + buttonLabel)
            return
        }

        applyPageNumber(Number(buttonLabel))
    }

    let buttons = buildPageSelection(pageNumber, numberOfPages, handleClick)

    return (
        <div className="page-selection-holder">
            <div className="page-selection-limit-holder">
                <span>Show </span>
                <select value={pageLimit} onChange={e => applyPageLimit(e.target.value)}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <span> of {stats.count?.toLocaleString() || 0} results</span>
            </div>
            <div className='page-selection-number-holder'>{buttons}</div>
        </div>
    )
}

export default PageSelector